// src/pages/PhotosGallery.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import PGalleryGrid from './PageComponent/PGalleryGrid';


function PhotosGallery() {
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Our Gallery | Callistus Blinds</title>
        <meta
          name="description"
          content="Explore our stunning gallery showcasing Callistus Blinds installations across homes and offices. Visit now to find inspiration for your space!"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/gallery/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Our Gallery" />
        <meta
          property="og:description"
          content="Explore our stunning gallery showcasing Callistus Blinds installations across homes and offices. Visit now to find inspiration for your space!"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/gallery/`} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <div>
        <Navbar />
        <NotificationBar />
        <PGalleryGrid />
        <Footer />
      </div>
    </>
  );
}

export default PhotosGallery;